<template>
  <div>
    <div class="container">
      <TextArea
        class="child"
        :textTitle="endpointName"
        :textLinesArray="endpointDesc"
      ></TextArea>
      <EndpointCard
        class="child"
        cardTitle="ENDPOINTS"
        :endpoints="endpoints"
      />
    </div>
    <div :ref="endpoints[0].ref" class="container">
      <Attribute
        class="child"
        :attributes="attributes"
        :endpoint="responseTitle"
      />
      <ResponseCard
        class="child"
        :response="response"
        :cardTitle="responseCodeTitle"
      />
      <Attribute
      class="child"
      :attributes="defaultWorkhourAttributes"
      :endpoint="defaultWorkhourAttributesTitle"
      />
      <div class="child"></div>
      <Attribute
      class="child"
      :attributes="dayOfWeekEnum"
      :endpoint="dayOfWeekEnumAttributesTitle"
      />
    </div>
    <div :ref="endpoints[2].ref" class="container">
      <div class="child">
        <TextArea :textTitle="postTitleCreate"></TextArea>
        <div>
          <Attribute :attributes="postAttributes" :textLinesArray="[]" endpoint="CreateFitterDTO" />
        </div>
      </div>
      <div class="child">
        <PostExample
          :postExample="postExample"
          cardTitle="POST /api/v4.0/fitters/create"
        />
        <ResponseCard
          class="mt-5"
          :response="postResponse"
          cardTitle="RESPONSE"
        />
    </div>
    </div>
    <div ref="POST" class="container">
      <div class="child">
        <TextArea :textTitle="postTitleUpdate" :textLinesArray="postDescUpdate"></TextArea>
        <div>
          <Attribute :attributes="postAttributesUpdate" endpoint="UpdateFitterDTO" />
        </div>
      </div>
      <div class="child">
        <PostExample
          :postExample="postExampleUpdate"
          cardTitle="POST /api/v4.0/fitters/update"
        />
        <ResponseCard
          class="mt-5"
          :response="postResponse"
          cardTitle="RESPONSE"
        />
    </div>
    </div>
  </div>
</template>

<style scoped>
.postCard {
  max-height: 600px;
}

.container {
  display: flex;
  flex-flow: row wrap;
  padding-left: 10rem;
  padding-right: 10rem;
}

.child {
  min-width: 40%;
  max-width: 45%;
  flex-grow: 1;
  flex-shrink: 1;
}

@media screen and (max-width: 500px) {
  .container {
    flex-flow: column wrap;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media screen and (max-width: 500px) {
  .child {
    max-width: 380px;
    min-width: 300px;
  }
}
</style>

<script>
import EndpointCard from "../../../components/content/EndpointCard.vue";
import Attribute from "../../../components/request/Attribute.vue";
import TextArea from "../../../components/content/TextArea.vue";
import ResponseCard from "../../../components/request/ResponseCard.vue";
import PostExample from "../../../components/request/PostExample.vue";

export default {
  components: {
    EndpointCard,
    Attribute,
    TextArea,
    ResponseCard,
    PostExample,
  },
  created() {
    this.$root.$on("scrollToEndpoint", (ref) => {
      var element = this.$refs[ref];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    });
  },
  computed: {
    endpointName() {
      return this.$t("fittersv4.endpointTitle");
    },
    filteringTitle() {
      return this.$t("fittersv4.filteringTitle");
    },
    filteringText() {
      return this.$t("fittersv4.filteringText");
    },
    endpointDesc() {
      return this.$t("fittersv4.endpointDesc");
    },
    endpoints() {
      return this.$t("fittersv4.controllerEndpoints");
    },
    responseTitle() {
      return this.$t("fittersv4.getTitle");
    },
    responseCodeTitle() {
      return this.$t("fittersv4.responseCodeTitle");
    },
    response() {
      return this.$t("fittersv4.getResponse");
    },
    attributes() {
      return this.$t("fittersv4.getAttributes");
    },
    defaultWorkhourAttributesTitle() {
      return this.$t("fittersv4.defaultWorkhourAttributesTitle");
    },
    defaultWorkhourAttributes() {
      return this.$t("fittersv4.getAttributes_defaultWorkhour");
    },
    dayOfWeekEnum() {
      return this.$t("fittersv4.getAttributes_dayOfWeekEnum");
    },
    dayOfWeekEnumAttributesTitle() {
      return this.$t("fittersv4.dayOfWeekEnumAttributesTitle");
    },
    postTitleCreate() {
      return this.$t("fittersv4.postTitleCreate");
    },
    postTitleUpdate() {
      return this.$t("fittersv4.postTitleUpdate");
    },
    postDescUpdate() {
      return this.$t("fittersv4.postDescUpdate");
    },
    postResponse() {
      return this.$t("fittersv4.postResponse");
    },
    postAttributes() {
      return this.$t("fittersv4.postAttributes_CreateFitterDTO");
    },
    postAttributesUpdate() {
      return this.$t("fittersv4.postAttributes_UpdateFitterDTO");
    },
    postExample() {
      return this.$t("fittersv4.postExampleCreate");
    },
    postExampleUpdate() {
      return this.$t("fittersv4.postExampleUpdate");
    },
  },
};
</script>